import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './AdminWidget.scss';
import '../Widgets.scss';
import request from 'superagent';
import moment from "moment";
import classNames from "classnames";

class AdminWidget extends Component {
    static propTypes = {
        userInfo: PropTypes.object,
        classPrefix: PropTypes.string,
        countRegistration: PropTypes.func,
    }

    constructor(props) {
        super(props)
        this.pageSetting = {
            title: 'Панель Администратора'
        };
        this.roleNames = {
            vendor: 'Дебитор',
            factor: 'Фактор',
            debtor: 'Покупатель',
        };
        this.state = {
            registration: [],
            activeCardIdx: null,
        }
    }

    reformatDate = date => {
        const now = moment().format('DD.MM.YYYY');
        const yesterday = moment().add(-1, 'days').format('DD.MM.YYYY');
        const tmp = moment(date).format('DD.MM.YYYY');
        return tmp === now ?
            'Сегодня' : yesterday === tmp ?
                'Вчера' : tmp
    }

    componentWillMount() {
        const {countRegistration} = this.props;
        request
            .get('http://localhost:8000/registration/view')
            .set({
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            })
            .send()
            .end((err, res) => {
                if (res) {
                   const cnt = res.body.res.length ?
                       res.body.res.filter(i => i.statusView === 'new') : [];
                    countRegistration(cnt.length);
                    this.setState({
                        registration: res.body.res,
                    })
                }
            });
    }

    updateRegistrationData = (id, params = null) => {

        request
            .post('http://localhost:8000/registration/update')
            .set({
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            })
            .send({
                    id: id,
                    params
                })
            .end((err, res) => {
                console.log(res.body);
                this.setState({err: err})});
    }

    handleCardClick = (index) => {
        const {registration} = this.state;
        const {countRegistration} = this.props;
        const paramForRequest = {
            statusView: 'read',
        };
        registration[index].statusView !== 'read' &&
        this.updateRegistrationData(registration[index].id, paramForRequest); // TODO промис условие если ошибка не менять статус сообщения
        registration[index].statusView = 'read';
            this.setState({
                activeCardIdx: index,
            })
        const cnt = registration.filter(i => i.statusView === 'new');
        countRegistration(cnt.length);

    }

    handleRegistration = (id, status) => {
        const {registration, activeCardIdx} = this.state;
        if (registration[activeCardIdx].status !== 'done') {
            this.updateRegistrationData(id, status);
            registration[activeCardIdx].status = 'done';
        }
        console.log(id) //TODO Метод для апдейта записи + добавление в реестр по роли
    }

    noticeFullInfo = () => {
        const {activeCardIdx, registration} = this.state;
        const item = registration[activeCardIdx];
        return registration[activeCardIdx] ?
            (
            <div className={'fullInfo'}>
                <div className={'top'}>
                    <div className={'company'}>
                        <div>{item.nameCompany}</div>
                        <div>{this.roleNames[item.role]}</div>
                    </div>
                    <div className={'properties'}>
                        <div><span>ОГРН:</span>{item.ogrn}</div>
                        <div><span>ОКПО: </span>{item.okpo}</div>
                        <div><span>ИНН: </span>{item.inn}</div>
                        <div><span>КПП: </span>{item.kpp}</div>
                    </div>
                </div>

                {item.status === 'review' ?
                    (
                        <div>
                            <div
                                className={'buttonNext'}
                                onClick={() => this.handleRegistration(item.id, {status: 'accept'})}>
                                Зарегестрировать
                            </div>
                            <div
                                className={classNames('buttonNext', 'reject')}
                                onClick={() => this.handleRegistration(item.id, {status:'reject'})}>
                                Отклонить
                            </div>
                        </div>
                    ) : null
                }

            </div>
        ) : (
                <div className={'fullInfo'}>
                    Полная информация
                </div>
            );
    }

    get noticeList() {
        const {registration, activeCardIdx} = this.state;
        return registration.map((item, i) => {
            return (
                <div key={`notice${i}`} className={classNames('noticeCard',
                    {'new': item.statusView === 'new',
                    'active': activeCardIdx === i,
                    'done': item.status !== 'review'})}
                    onClick={() => this.handleCardClick(i)}>
                    <div className={'title'}>
                        <span>Запрос на регистрацию</span>
                        <div className={'date'}>{this.reformatDate(item.dateCreate)}</div>
                        <div className={classNames('status', item.status)}/>
                    </div>
                    <div className={'fio'}>
                        <div>{item.name}</div>
                        <div>{item.middleName}</div>
                        <div>{item.surename}</div>
                    </div>
                    <div className={'company'}>
                        <div className={'item'}>{`Компания: `}<span>{item.nameCompany}</span></div>
                        <div className={'item'}>{`тел.: `}<span>{item.phone}</span></div>
                        <div className={'item'}>{`e-mail: `}<span>{item.email}</span></div>
                    </div>
                </div>
            )
        })

    }

    render() {
        const {classPrefix} = this.props;
        const {title} = this.pageSetting;

        return (<div className={`contentBody${classPrefix}`}>
            <div className={'widgetTitle'}>
                {title}
            </div>
            <div className={`adminContent${classPrefix}`}>
                <div className={'noticeList'}>
                    {this.noticeList}
                </div>
                {this.noticeFullInfo()}
            </div>
        </div>)
    }
}

export default AdminWidget


// WEBPACK FOOTER //
// ./src/Widget/AdminWidget/AdminWidget.js